export const findOptionsToConvert = (currentField, options) => {
    if (options.find((item) => item == currentField)) {
        return true;
    }

    return false;
};

export const registerFiledsToConvert = () => {
    const fields = ['ethnicity', 'gender', 'type_of_support', 'carers_allowance', 'support'];

    return fields;
};

export const convertFieldsFromRegisterToNumber = (data) => {
    for (const property in data) {
        if (findOptionsToConvert(property, registerFiledsToConvert())) {
            if (typeof data[property] === 'object') {
                for (const item in data[property]) {
                    data[property][item] = parseInt(data[property][item]);
                }
            } else {
                data[property] = parseInt(data[property]);
            }
        }
    }

    return data;
};
